import { Link, useLocation } from "react-router-dom";

export function SidebarItem({ icon, text, expanded, path }) {
  const location = useLocation();
  const isActive = location.pathname === path; 

  return (
    <Link to={path}>
      <li
        className={`
    group relative flex items-center py-2 sm:px-3 px-2 my-1
    font-medium rounded-md cursor-pointer
    transition-colors
    ${
      isActive
        ? "sm:bg-indigo-200 bg-indigo-100 text-indigo-800" // Darker bg when active
        : "sm:hover:bg-indigo-200 text-text"
    }
  `}
      >
        <div
          className={`flex items-center w-full sm:justify-center justify-start sm:ml-0 ${
            expanded ? "gap-3" : "gap-0"
          }`}
        >
          {icon}
          <span
            className={`overflow-hidden transition-all sm:font-semibold ml-2 sm:ml-0 font-normal ${
              expanded ? "w-52 ml-3" : "sm:w-0"
            }`}
          >
            {text}
          </span>
        </div>

        {/* Tooltip visible when the sidebar is collapsed and mouse hovers over the item */}
        {!expanded && (
          <div
            id="sidebar-tooltip"
            className={`
        fixed sm:block hidden left-3 top-auto rounded-md px-3 py-1
        bg-indigo-100 text-indigo-800 text-sm opacity-0 invisible
        transition-opacity duration-200
        group-hover:opacity-100 group-hover:visible
        z-50
      `}
            style={{ marginLeft: "4rem" }}
          >
            {text}
          </div>
        )}
      </li>
    </Link>
  );
}
